/**
 * Earth's hemispheres.
 */
export enum Hemisphere {
  NORTHERN = "Northern",
  SOUTHERN = "Southern",
}
